import STTypo from 'core/shared/typo';
import { TypeOptions } from 'core/shared/typo/typo.models';
import SvgArrowLeftGlyph from 'st-protector-icons/Glyph/ArrowLeftGlyph';
import { BackButton, HeaderContainer } from './header.styles';

interface HeaderProps {
  onClickBack: () => void;
  title: string;
  subtitle?: string;
}

export const Header = ({ onClickBack, title, subtitle }: HeaderProps): JSX.Element => {
  return (
    <HeaderContainer>
      <BackButton onClick={onClickBack} data-testid='header-back-button'>
        <SvgArrowLeftGlyph fill='#707374' />
      </BackButton>
      <STTypo fontWeight={500} type={TypeOptions.H4}>
        {subtitle ? `${title} • ${subtitle}` : title}
      </STTypo>
    </HeaderContainer>
  );
};
